import { render, staticRenderFns } from "./autoReplace.vue?vue&type=template&id=3bca617c"
import script from "./autoReplace.vue?vue&type=script&lang=js"
export * from "./autoReplace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports